<template>
  <header>
    <div class="logo"><img src="../assets/img/logo-h2o.png" /></div>
    <nav class="navbar" v-if="authStore.isLoggedIn">
      <div class="hamburger" :class="{ 'is-active': isOpen }" @click="toggle" id="hamburger-1">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <div class="menu-header" :class="{ 'is-open': isOpen }">
        <div class="mt-80">
          <li>
            <router-link class="mt-35" :to="{ name: 'Historial' }" @click="toggle">Historial de pases</router-link>
          </li>
          <li>
            <Button type="button" text="Cerrar sesión" classtype="secondary" @click="logOut" />
          </li>
        </div>
      </div>
    </nav>
  </header>
</template>
<script setup>
import { ref } from "vue"
import { useAuthStore } from "@/store"
import Button from "./Button.vue"
const isOpen = ref(false)
const authStore = useAuthStore()

const toggle = () => {
  isOpen.value = !isOpen.value
}
const logOut = () => {
  authStore.logout().catch((err) => {
    console.log(err, "upss seguis logueado")
  })
}
</script>
<style>
header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px 0;
  z-index: 2;
}

.logo {
  margin-left: 20px;
}

img {
  max-width: 137px;
}

/* ALL */

.hamburger .line {
  width: 29px;
  height: 2px;
  background-color: #ecf0f1;
  display: block;
  margin: 8px auto;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.hamburger:hover {
  cursor: pointer;
}

/* ONE */

#hamburger-1.is-active .line:nth-child(2) {
  opacity: 0;
}

#hamburger-1.is-active .line:nth-child(1) {
  -webkit-transform: translateY(13px) rotate(45deg);
  -ms-transform: translateY(13px) rotate(45deg);
  -o-transform: translateY(13px) rotate(45deg);
  transform: translateY(13px) rotate(45deg);
}

#hamburger-1.is-active .line:nth-child(3) {
  -webkit-transform: translateY(-13px) rotate(-45deg);
  -ms-transform: translateY(-13px) rotate(-45deg);
  -o-transform: translateY(-13px) rotate(-45deg);
  transform: translateY(-13px) rotate(-45deg);
}

@keyframes smallbig {
  0%,
  100% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    -o-transform: scale(0);
    transform: scale(0);
  }
}

.navbar {
  margin-right: 20px;
}

.navbar .menu-header {
  position: fixed;
  top: 0;
  box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.5);
  min-height: 100vh;
  width: 100%;
  transform: translateX(101%);
  display: flex;
  flex-direction: column;
  transition: transform 0.5s ease-in-out;
  align-items: center;
  right: 0;
  background-color: #075eb0;
  z-index: -1;
}

.navbar .menu-header li {
  font-size: 1.1rem;
  font-weight: 500;
  list-style-type: none;
  color: #fff;
  margin-top: 40px;
}

.navbar .is-open {
  transform: translate(0);
}

@media (min-width: 720px) {
  .logo {
    margin-left: 50px;
  }

  .navbar .menu-header {
    width: 420px;
  }
}
</style>
